import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AddFiles } from '../../components/AddFiles/AddFiles';
import { Footer } from '../../shared/Footer/Footer';
import { Header } from '../../shared/Header/Header';
import { PassportSelect } from '../../components/PassportSelect/PassportSelect';
import {
  checkToken,
  redirectFrom,
  setLang,
  setSubTitle,
  setTitle,
  throwErrorMessage,
} from '../../actions/Actions';
import './Upload.scss';
import ToolBar from '../../shared/ToolBar/ToolBar';
import reflect from '../../translate/translations';
import { useHistory } from 'react-router-dom';

export default function Upload() {
  const dispatch = useDispatch();

  const router = useSelector((state) => state.router.location);
  const [header, setHeader] = useState(null);
  const [subHeader, setSubHeader] = useState(null);
  const [isForMobi, setIsForMobi] = useState(false);
  const history = useHistory();
  useEffect(() => {
    const { query } = router;
    switch (router.pathname) {
      case '/alifshop':
        dispatch(redirectFrom('alifshop'));
        dispatch(setLang(query?.lang));
        dispatch(setTitle(reflect.t('request_accepted')));
        if (
          !query.hasOwnProperty('apiKey') ||
          query?.apiKey?.length === 0 ||
          !query?.apiKey
        ) {
          dispatch(setLang(query?.lang));
          dispatch(throwErrorMessage('tokenNotFound'));
        } else {
          setHeader(reflect.t('last_step'));
          setSubHeader(reflect.t('for_complete_request'));
          dispatch(checkToken(query.apiKey, history));
        }
        break;
      case '/km':
        dispatch(redirectFrom('km'));
        dispatch(setLang(query?.lang));
        dispatch(setTitle(reflect.t('request_accepted')));
        dispatch(setSubTitle(reflect.t('courier_delivery_card')));
        if (
          !query.hasOwnProperty('apiKey') ||
          query?.apiKey?.length === 0 ||
          !query?.apiKey
        ) {
          dispatch(setLang(query?.lang));
          dispatch(throwErrorMessage('tokenNotFound'));
        } else {
          setHeader(reflect.t('last_step'));
          setSubHeader(reflect.t('for_complete_request'));
          dispatch(checkToken(query.apiKey, history));
        }
        break;
      case '/visa':
        dispatch(redirectFrom('visa'));
        dispatch(setLang(query?.lang));
        dispatch(setTitle(reflect.t('request_accepted')));
        dispatch(setSubTitle(reflect.t('courier_delivery_card_visa')));
        if (
          !query.hasOwnProperty('apiKey') ||
          query?.apiKey?.length === 0 ||
          !query?.apiKey
        ) {
          dispatch(setLang(query?.lang));
          dispatch(throwErrorMessage('tokenNotFound'));
        } else {
          setHeader(reflect.t('last_step'));
          setSubHeader(reflect.t('for_complete_request'));
          dispatch(checkToken(query.apiKey, history));
        }
        break;
      case '/sm':
        dispatch(redirectFrom('sm'));
        dispatch(setTitle(reflect.t('request_accepted')));
        dispatch(setSubTitle(reflect.t('app_confirmation')));
        if (
          !query.hasOwnProperty('apiKey') ||
          query?.apiKey?.length === 0 ||
          !query?.apiKey
        ) {
          dispatch(throwErrorMessage('tokenNotFound'));
        } else {
          dispatch(checkToken(query.apiKey, history));
        }
        break;
      case '/auto':
        dispatch(redirectFrom('auto'));
        if (
          !query.hasOwnProperty('apiKey') ||
          query?.apiKey?.length === 0 ||
          !query?.apiKey
        ) {
          dispatch(throwErrorMessage('tokenNotFound'));
        } else {
          dispatch(setTitle(reflect.t('request_accepted')));
          dispatch(setSubTitle(reflect.t('auto_request')));
          dispatch(checkToken(query.apiKey, history));
        }
        break;
      case '/mobi':
        dispatch(redirectFrom('mobi'));
        setIsForMobi(true);
        if (
          !query.hasOwnProperty('wallet') ||
          query?.wallet?.length === 0 ||
          !query?.wallet
        ) {
          dispatch(throwErrorMessage('tokenNotFound'));
        } else {
        }
        break;
      default:
        break;
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div className="Upload">
      <div className="container">
        <ToolBar />
        <Header title={header} subHeader={subHeader} />
        {!isForMobi && <PassportSelect />}
        <AddFiles isForMobi={isForMobi} />
      </div>
      <div className="uploadFooter">
        <Footer />
      </div>
    </div>
  );
}
